import React, { useLayoutEffect, useRef } from 'react';

import { Chart } from 'chart.js';
import PropTypes from 'prop-types';

import { LineChartContainer } from './style';

const LineChart = ({ dataset: info, lineStyle = {} }) => {
  const ref = useRef();

  useLayoutEffect(() => {
    const data = {
      labels: info?.labels,
      datasets: info?.datasets
        ? info?.datasets
        : [
            {
              data: info?.data
            }
          ]
    };
    const { options } = lineStyle;
    // eslint-disable-next-line no-new
    new Chart(ref.current, {
      type: 'line',
      data,
      options
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LineChartContainer>
      <canvas ref={ref} />
    </LineChartContainer>
  );
};

LineChart.propTypes = {
  dataset: PropTypes.object,
  lineStyle: PropTypes.object
};

export default LineChart;
